import { render, staticRenderFns } from "./z2Cell.vue?vue&type=template&id=2e0b7154&scoped=true&"
import script from "./z2Cell.vue?vue&type=script&lang=js&"
export * from "./z2Cell.vue?vue&type=script&lang=js&"
import style0 from "./z2Cell.vue?vue&type=style&index=0&id=2e0b7154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0b7154",
  null
  
)

export default component.exports